// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZWVw","index":"styles_index__2J9Y1"};